import ptBr from 'antd/locale/pt_BR';
import type { Locale } from 'antd/lib/locale'; // auto detect the user language, more information here: https://github.com/i18next/i18next-browser-languageDetector

export const ptBrLocale: Locale = {
  ...ptBr,
  Table: {
    ...ptBr.Table,
    cancelSort: 'Cancelar ordenação',
    triggerAsc: 'Ordem ascendente',
    triggerDesc: 'Ordem descendente'
  }
};
